var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1681 6.18401H9.92006V7.14393H14.1681C14.4801 7.14393 14.7201 7.384 14.7201 7.67193V18.3519C14.7201 18.6399 14.48 18.8799 14.1681 18.8799H1.83211C1.52006 18.8799 1.28015 18.6399 1.28015 18.3519V7.69593C1.28015 7.40798 1.52022 7.16793 1.83211 7.16793L5.60019 7.16809V6.20818L1.83211 6.20801C0.992025 6.20801 0.320068 6.88001 0.320068 7.69597V18.376C0.320068 19.1919 0.992068 19.8639 1.83211 19.8639H14.1681C15.0082 19.8639 15.6801 19.1919 15.6801 18.376V7.69597C15.6801 6.85606 15.0081 6.1841 14.1683 6.1841L14.1681 6.18401Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52021 1.72004V14.296H8.48013V1.72004L10.9521 3.544L11.5282 2.77608L8.00017 0.159958L4.47217 2.77608L5.04821 3.544L7.52021 1.72004Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.789dce360cd3c242fd95f4f30cf91e47.svg";
export { ForwardRef as ReactComponent };